import React, {useState} from "react";

import {Loader} from "../../components/loading/Loader";

import {InfoCard} from "../../components/infoCard/InfoCard";
import {StyledTable} from "../../components/styledTable/StyledTable";
import {useCreateColumns} from "../../components/styledTable/useCreateColumns";
import {buildColumnData, getTotalCount} from "./leadersBulletinHelper";
import {useGetLeadersBulletin} from "../../services/api/event/leadersBulletin/useGetLeadersBulletin";

import styles from "./LeadersBulletin.module.scss";

type Status = "EMD" | "email";

export default function LeadersBulletin() {
  const [status, setStatus] = useState<Status>("EMD");
  const {data: leadersBulletinData, isPending: isLeadersBulletinDataPending} =
    useGetLeadersBulletin();

  const tableData =
    status === "EMD"
      ? leadersBulletinData?.emdOrderCounts
      : leadersBulletinData?.emailOrderCounts;

  const columnData = useCreateColumns({
    tableData: tableData ?? [],
    columnData: buildColumnData(),
  });

  const totalOrders = getTotalCount(tableData ?? []);

  if (!tableData || isLeadersBulletinDataPending)
    return <Loader type="color" />;

  const TableInfoCards = () => {
    return (
      <div className={styles.tableInfoCards}>
        <InfoCard title="Total Orders" subtitle={totalOrders} />
        <InfoCard title="Team Target" subtitle={2000} />
      </div>
    );
  };

  return (
    <div className={styles.screen}>
      <TableInfoCards />
      <StyledTable
        data={tableData}
        columns={columnData}
        showPagination={true}
      />
    </div>
  );
}
